<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-row>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="12">
                                    <h1 class="text-center">Users</h1>
                                </v-col>
                            </v-row>
                            <v-row >
                                <v-col cols="12" sm="3" offset-sm="1">
                                    <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Filter Users"
                                        single-line
                                        hide-details
                                        clearable
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" offset-sm="1">
                                    <v-checkbox
                                        label="Active Only"
                                        v-model="activeOnly"
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="2" offset-sm="1">
                                    <v-btn
                                        v-if="!auth.currentUserIsReadOnly()"
                                        color="success"
                                        block
                                        @click="editUser()"
                                    >
                                        Add
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-data-table
                                        :headers="headers"
                                        :items="users"
                                        :loading="loading"
                                        :search="search"
                                        must-sort
                                    >
                                        <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                        <template slot="item" slot-scope="props">
                                            <tr :data-id="props.item.ID">
                                                <td>{{props.item.Email}}</td>
                                                <td>{{props.item.FirstName}}</td>
                                                <td>{{props.item.LastName}}</td>
                                                <td v-if="props.item.Permissions[permissions.ACCESS_LEVELS.ACCESS]"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.Permissions[permissions.ACCESS_LEVELS.ACCESS]"><v-icon color="error">close</v-icon></td>
                                                <td v-if="props.item.Permissions[permissions.ACCESS_LEVELS.ADMIN]"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.Permissions[permissions.ACCESS_LEVELS.ADMIN]"><v-icon color="error">close</v-icon></td>
                                                <td v-if="props.item.Permissions[permissions.ACCESS_LEVELS.NEW_SPECIMEN]"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.Permissions[permissions.ACCESS_LEVELS.NEW_SPECIMEN]"><v-icon color="error">close</v-icon></td>
                                                <td v-if="props.item.Permissions[permissions.ACCESS_LEVELS.DAILY_HUSBANDRY]"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.Permissions[permissions.ACCESS_LEVELS.DAILY_HUSBANDRY]"><v-icon color="error">close</v-icon></td>
                                                <td v-if="props.item.Permissions[permissions.ACCESS_LEVELS.VET_MED_TEAM]"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.Permissions[permissions.ACCESS_LEVELS.VET_MED_TEAM]"><v-icon color="error">close</v-icon></td>
                                                <td v-if="props.item.Permissions[permissions.ACCESS_LEVELS.VENOM_PROFILE]"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.Permissions[permissions.ACCESS_LEVELS.VENOM_PROFILE]"><v-icon color="error">close</v-icon></td>
                                                <td v-if="props.item.Permissions[permissions.ACCESS_LEVELS.DAILY_EXTRACTION]"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.Permissions[permissions.ACCESS_LEVELS.DAILY_EXTRACTION]"><v-icon color="error">close</v-icon></td>
                                                <td v-if="props.item.Permissions[permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS]"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.Permissions[permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS]"><v-icon color="error">close</v-icon></td>
                                                <td v-if="props.item.Permissions[permissions.ACCESS_LEVELS.RELEASE_CERTIFICATE]"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.Permissions[permissions.ACCESS_LEVELS.RELEASE_CERTIFICATE]"><v-icon color="error">close</v-icon></td>
                                                <td v-if="props.item.Permissions[permissions.ACCESS_LEVELS.READ_ONLY]"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.Permissions[permissions.ACCESS_LEVELS.READ_ONLY]"><v-icon color="error">close</v-icon></td>
                                                <td v-if="props.item.ImageS3Path"><v-icon color="success">check</v-icon></td>
                                                <td v-if="!props.item.ImageS3Path"><v-icon color="error">close</v-icon></td>
                                                <td>
                                                    <v-btn
                                                        v-if="canEdit(props.item)"
                                                        color="warning"
                                                        block
                                                        @click="editUser(props.item)"
                                                    >
                                                        Edit
                                                    </v-btn>
                                                </td>
                                                <td>
                                                    <v-btn
                                                        v-if="props.item.ImageS3Path"
                                                        color="info"
                                                        block
                                                        @click="showUploadImageDialog(props.item.Email)"
                                                    >
                                                        Edit Signature
                                                    </v-btn>
                                                    <v-btn
                                                        v-else-if="!props.item.ImageS3Path"
                                                        color="accent"
                                                        block
                                                        @click="showUploadImageDialog(props.item.Email)"
                                                    >
                                                        Upload Signature
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-if="!loading" slot="no-data">
                                            <v-alert v-if="loadError" outlined :value="true" color="error" icon="error">
                                                {{loadError}}
                                            </v-alert>
                                            <v-alert v-if="!loadError" outlined :value="true" type="info">
                                                No results found
                                            </v-alert>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-dialog v-model="showUploadDialog" v-if="showUploadDialog" max-width="600px" hide-overlay transition="dialog-bottom-transition">
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-btn icon dark :disabled="saving" @click="showUploadDialog = false">
                                        <v-icon large>close</v-icon>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title>Upload Signature</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        
                                    </v-toolbar-items>
                                </v-toolbar>
                                <UploadSignature :email="uploadImageUser" @closeUploadDialog="closeUploadDialog" @created="loadUsers" > </UploadSignature>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="showEditDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-btn icon dark :disabled="saving" @click="cancelEditUser">
                                        <v-icon large>close</v-icon>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title v-if="editedUser && editedUser.newUser">Add New User</v-toolbar-title>
                                    <v-toolbar-title v-else>Edit User</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-form @submit.prevent ref="editForm" v-model="editUserValid">
                                    <v-row class="dialog-content">
                                        <v-col cols="12" md="6" offset-md="3">
                                            <v-row >
                                                <v-col cols="12" v-if="!(editedUser && editedUser.newUser)">
                                                    <v-alert
                                                        v-model="infoVisible"
                                                        outlined
                                                        dismissible
                                                        type="info">
                                                        Some information cannot be edited through Colossus - please contact a system administrator
                                                    </v-alert>
                                                </v-col>
                                                <v-col cols="12" v-if="editedUser && editedUser.newUser">
                                                    <v-text-field
                                                        clearable
                                                        counter="100"
                                                        maxlength="100"
                                                        v-model="editedUser.Email"
                                                        :rules="[rules.required, rules.email]"
                                                        label="User Email">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" v-else>
                                                    <v-text-field
                                                        v-model="editedUser.Email"
                                                        :readonly="true"
                                                        label="User Email"
                                                        append-icon="info"
                                                        @click:append="showInfo"
                                                    >       
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field
                                                        v-model="editedUser.FirstName"
                                                        label="First Name">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field
                                                        v-model="editedUser.LastName"
                                                        label="Last Name">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-row >
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="Active" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.ACCESS]"></v-checkbox>
                                                            <p class="permission-explainer">Allows the user to access the site once logged in.</p>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="Admin" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.ADMIN]"></v-checkbox>
                                                            <p class="permission-explainer">Allows the user to perform all system functionality.</p>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="New Specimen Management" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.NEW_SPECIMEN]"></v-checkbox>
                                                            <p class="permission-explainer">Allows the user to create new specimen records.</p>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="Daily Husbandry" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.DAILY_HUSBANDRY]"></v-checkbox>
                                                            <p class="permission-explainer">Allows the user to enter husbandry data.</p>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="Venom Profile" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.VENOM_PROFILE]"></v-checkbox>
                                                            <p class="permission-explainer">Allows the user to enter modify venom profiles.</p>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="Daily Extraction" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.DAILY_EXTRACTION]"></v-checkbox>
                                                            <p class="permission-explainer">Allows the user to manage and create daily extractions.</p>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="Monthly Pool/Venom Lots" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS]"></v-checkbox>
                                                            <p class="permission-explainer">Allows the user to manage and create monthly pools and venom lots.</p>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="Release Certificate" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.RELEASE_CERTIFICATE]"></v-checkbox>
                                                            <p class="permission-explainer">Allows the user to view Release Certificates for Venom Lots.</p>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="Vet Med Tasks" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.VET_MED_TEAM]"></v-checkbox>
                                                            <p class="permission-explainer">Allows the user to save and close medical records.</p>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="Medical Record Access" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.MEDICAL_RECORD_ACCESS]" :disabled="true"></v-checkbox>
                                                            <p class="permission-explainer">Access to medical records - this is inferred from access to either Daily Husbandry or Vet Med Tasks.</p>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-checkbox label="Read Only" v-model="editedUser.Permissions[permissions.ACCESS_LEVELS.READ_ONLY]"></v-checkbox>
                                                            <p class="permission-explainer">Prevents the user from making any changes to data in the system. As long as they have the appropriate permissions, they are still able to view data.</p>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                            <v-row  class="dialog-action-buttons">
                                                <v-col cols="12" sm="6">
                                                    <v-btn block color="error" :disabled="saving" @click="cancelEditUser">Cancel</v-btn>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-btn block color="success" :disabled="!editUserValid" :loading="saving" @click="saveEditedUser">Save</v-btn>
                                                </v-col>
                                                <v-col cols="12" v-if="saveError">
                                                    <v-alert text type="error">{{ saveError }}</v-alert>
                                                </v-col>
                                            </v-row>                            
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<style>
    
</style>

<script>
import validationRules from "../../helpers/validationrules";
import * as auth from '@/services/auth';
import permissions from 'comunet-btg-utah-repository-shared/permissions';
import util from '@/helpers/util';
import UploadSignature from './UploadSignature';

export default {
    components: {
        UploadSignature
    },
    props: [
        
    ],
    data() {
        return {
            auth: auth,
            permissions: permissions,
            infoVisible: false,
            editedUser: {
                Permissions: {}
            },
            showEditDialog: false,
            showUploadDialog: false,
            uploadImageUser: "",
            editUserValid: false,
            search: "",
            activeOnly: true,
            rules: validationRules.rules,
            headers: [
                {
                    text: "Email",
                    value: "Email"
                },
                {
                    text: "First Name",
                    value: "FirstName"
                },
                {
                    text: "Last Name",
                    value: "LastName"
                },
                {
                    text: "Active",
                    value: "Permissions[permissions.ACCESS_LEVELS.ACCESS]"
                },
                {
                    text: "Admin",
                    value: "Permissions[permissions.ACCESS_LEVELS.ADMIN]"
                },
                {
                    text: "New Specimen Management",
                    value: "Permissions[permissions.ACCESS_LEVELS.NEW_SPECIMEN]"
                },
                {
                    text: "Daily Husbandry",
                    value: "Permissions[permissions.ACCESS_LEVELS.DAILY_HUSBANDRY]"
                },
                  {
                    text: "Vet Med Team",
                    value: "Permissions[permissions.ACCESS_LEVELS.VET_MED_TEAM]"
                },
                {
                    text: "Venom Profile",
                    value: "Permissions[permissions.ACCESS_LEVELS.VENOM_PROFILE]"
                },
                {
                    text: "Daily Extraction",
                    value: "Permissions[permissions.ACCESS_LEVELS.DAILY_EXTRACTION]"
                },
                {
                    text: "Monthly Pool/Venom Lots",
                    value: "Permissions[permissions.ACCESS_LEVELS.MONTHLY_POOL_VENOM_LOTS]"
                },
                {
                    text: "Release Certificate",
                    value: "Permissions[permissions.ACCESS_LEVELS.RELEASE_CERTIFICATE]"
                },
                {
                    text: "Read Only",
                    value: "Permissions[permissions.ACCESS_LEVELS.READ_ONLY]"
                },
                {
                    text: "Signature",
                    value: "ImageS3Path"
                },
                {
                    text: "", // edit button
                    sortable: false
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.userStore.loading;
        },
        loadError() {
            return this.$store.state.userStore.loadError;
        },
        saving() {
            return this.$store.state.userStore.saving;
        },
        saveError() {
            return this.$store.state.userStore.saveError;
        },
        users() {
            return this.$store.state.userStore.users.filter(u => (u.Permissions && u.Permissions.access) || !this.activeOnly);
        },
        editedUserPermissions() {
            return this.editedUser.Permissions
        }
    },
    watch: {
        editedUserPermissions: {
            handler(val) {
                // console.log("A")
                // console.log(val[permissions.ACCESS_LEVELS.VET_MED_TEAM] || val[permissions.ACCESS_LEVELS.DAILY_HUSBANDRY])
                // console.log("A")
                if (val[permissions.ACCESS_LEVELS.VET_MED_TEAM] || val[permissions.ACCESS_LEVELS.DAILY_HUSBANDRY]) {
                    // console.log("B")
                    this.editedUser.Permissions[permissions.ACCESS_LEVELS.MEDICAL_RECORD_ACCESS] = true;
                } else if (!val[permissions.ACCESS_LEVELS.VET_MED_TEAM] && !val[permissions.ACCESS_LEVELS.DAILY_HUSBANDRY])  {
                    // console.log("C")
                    this.editedUser.Permissions[permissions.ACCESS_LEVELS.MEDICAL_RECORD_ACCESS] = false;
                }
            },
            deep: true
        }
    },
    methods: {
        showInfo() {
            this.infoVisible = true;
        },
        phoneMask(value) {
            return validationRules.phoneMask(value);
        },
        loadUsers() {
            this.$store.dispatch("userStore/loadUsers");
        },
        editUser(item) {
            this.editedUser = Object.assign({
                Permissions: {}
            }, item);

            this.editedUser.newUser = !(item && item.Email);

            this.showEditDialog = true;

            // show which fields are mandatory when opening the edit form
            this.$nextTick(() => this.$refs.editForm.validate());
        },
        cancelEditUser() {
            this.showEditDialog = false;
            this.editedUser = {
                Permissions: {}
            };
        },
        showUploadImageDialog(email){
            this.showUploadDialog = true;
            this.uploadImageUser = email;
        },
        closeUploadDialog(){
            this.showUploadDialog = false;
        },
        saveEditedUser() {
            var that = this;

            this.$store.dispatch("userStore/saveUser", {
                user: this.editedUser,
                finally: function() {
                    if (that.$store.state.userStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditUser();
                    }
                }
            });
        },
        canEdit(item) {
            let loggedInUser = util.getUserProfileFromUserObject(this.$store.state.authStore.user);

            if(loggedInUser.Email == item.Email) {
                return false;
            }

            // don't show the edit button if we are a read only user
            if (auth.currentUserIsReadOnly()) {
                return false;
            }

            return true;
        }
    },
    created() {
        this.loadUsers();
    }
};
</script>